import { pushAheadOfUpstreamForPaths } from '../../../git/status/index.js';
import type { SessionWorktreeCache } from '../session-worktree-cache.js';
import { resolveCommitTargetsAsync } from '../resolve-commit-targets.js';
import type { SessionDiscover } from './types.js';

export async function pushSessionUpstream(
  cache: SessionWorktreeCache,
  sessionId: string,
  discover: SessionDiscover,
): Promise<{ ok: boolean; error?: string }> {
  try {
    await pushAheadOfUpstreamForPaths(await resolveCommitTargetsAsync(sessionId, cache, discover));
    return { ok: true };
  } catch (e) {
    const err = e instanceof Error ? e.message : String(e);
    return { ok: false, error: err };
  }
}
